import assign from 'lodash/object/assign';

export default ngModule => {
  /**
   * Make a function that we can resolve from preSubmitFunction to modify the application object
   * The idea is preSubmitFunctions run async and then can resolve a function which will get
   * called and passed in the application object so can modify it as required (eg. scrub
   * sensitive credit card details, replace with token etc)
   * @param application
   */
  function makeApplicationTransformFunction(tokeniseResult) {
    return application => {
      application.payment.credit_card = {};
      application.payment.bpointResultKey = tokeniseResult.ResultKey;
      return application;
    }
  }
  ngModule.controller('ComparatorStep3CtrlHBF', function ($scope, $q, BPointApi, AonApplicationService) {
    this.ctrl = $scope.$parent.ctrl;
    const {BANK_ACCOUNT, CREDIT_CARD} = this.ctrl.fieldsets.payment.type.constants;
    this.ctrl.application.service_selection = this.ctrl.application.service_selection || [];
    this.ctrl.preSubmitFunctions.push(application => {

      const {contact: {email_address}, payment} = application;
      const deferred = $q.defer();
      switch (payment.type) {
        /*
         * Bank account is supported by bpoint but looks like HBF don't use it
        case BANK_ACCOUNT:
           BPointApi.tokeniseBankAccount(payment.bank_account, {email_address, reference}).then(
            result => deferred.resolve(makeApplicationTransformFunction(result)),
            errors => deferred.reject({'payment.bank_account': errors})
          );
          break;
          */
        case CREDIT_CARD:
          const tokenise = crn => {
            BPointApi.tokeniseCreditCard(payment.credit_card, {email_address, reference: crn}).then(
              result => deferred.resolve(makeApplicationTransformFunction(result)),
              errors => deferred.reject({payment: {credit_card: errors}})
            );
          };
          AonApplicationService.generateCustomerReference().then(
            reference => tokenise(reference),
            // If fail to generate one from server fallback to this
            error => tokenise('TS'+(new Date()).time)
          );
          break;
        default:
          // Unless it's credit card we we don't need to do anything else so we can resolve straight away
          deferred.resolve();
      }

      return deferred.promise;
    });
  });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step3-ctrl-hbf.js